import React, { useState } from "react";
import "../../styles/common-styles.css";
import { Group } from "../../exports/Images";

const ScrollableGrid = ({
  tabName,
  statsData,
  selectedCard,
  setSelectedCard,
  setSelectedTrainer,
  tableRef,
}) => {
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(null);
  const [scrollLeft, setScrollLeft] = useState(null);

  const handleMouseDown = (e) => {
    setIsDown(true);
    e.currentTarget.classList.add("active");
    setStartX(e.pageX - e.currentTarget.offsetLeft);
    setScrollLeft(e.currentTarget.scrollLeft);
  };

  const handleMouseLeave = (e) => {
    setIsDown(false);
    e.currentTarget.classList.remove("active");
  };

  const handleMouseUp = (e) => {
    setIsDown(false);
    e.currentTarget.classList.remove("active");
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - e.currentTarget.offsetLeft;
    const walk = (x - startX) * 3;
    e.currentTarget.scrollLeft = scrollLeft - walk;
  };

  const handleCardClick = (event, index, trainerId) => {
    event.stopPropagation();

    if (selectedCard === index) {
      setSelectedCard(null);
      setSelectedTrainer(null);
    } else {
      setSelectedCard(index);
      setSelectedTrainer(trainerId);
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="grid-container">
      <main className="grid-item main">
        <div
          className="items"
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {tabName === "renewals" && (
            <>
              {statsData?.map((item, index) => (
                <div
                  // className="item"
                  key={index}
                  tabIndex={0}
                  onClick={(event) =>
                    handleCardClick(event, index, item?.trainer_id)
                  }
                  className={`item item${index + 1} ${
                    selectedCard === index ? "active" : ""
                  }`}
                >
                  <div
                    className={`owlItemInnerContainer lessInformation ${
                      selectedCard === index ? "active" : ""
                    }`}
                  >
                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">{item?.trainer_name || "N/A"}</p>
                    </div>

                    <div className="listFooter">
                      <span className="listName">{item?.members || "N/A"}</span>
                      <p className="listValue">Members</p>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          {tabName === "recent-renewals" && (
            <>
              <div className="item">
                <div className="owlItemInnerContainer greenCards">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <p className="name">Rahul sharma</p>
                      <span className="position">Goal focused Plan</span>
                      <span className="position date">31-10-2023</span>
                    </div>
                  </div>

                  <div className="listFooter">
                    <span className="listName">Amount Paid-</span>
                    <p className="listValue">₹23,999</p>
                  </div>

                  <span className="taggedName">Rahul Sharma</span>
                </div>
              </div>
            </>
          )}

          {tabName === "incentives" && (
            <>
              <div className="item">
                <div className="owlItemInnerContainer">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="owlItemInnerContainer active">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="owlItemInnerContainer">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="owlItemInnerContainer">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="owlItemInnerContainer">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="owlItemInnerContainer">
                  <div className="imgPositionName">
                    <div className="img">
                      <img src={Group} alt="profile-p" />
                    </div>

                    <div className="positionName">
                      <span className="position">Trainer</span>
                      <p className="name">Rahul sharma</p>
                    </div>
                  </div>

                  <ul className="lists">
                    <li className="lists-item">
                      <span className="listName">Base salary</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Rewards</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Renewals</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                    <li className="lists-item">
                      <span className="listName">Penalty</span>
                      <p className="listValue">+₹14,000</p>
                    </li>
                  </ul>

                  <div className="listFooter">
                    <span className="listName">Total</span>
                    <p className="listValue">+₹14,000</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default ScrollableGrid;
